import { apiVersions, getLogicEndpoint } from './endpoints';
import { appFetch } from './appClient';

/**
 * Interface representing a workflow assistant feature.
 */
export interface WorkflowAssistantFeature {
  featureName: string;
  value: boolean;
}

interface WorkflowAssistantFeaturesResponse {
  features?: WorkflowAssistantFeature[];
}

/**
 * Member functions for workflow-assistant feature.
 */
export const CREATE_WORKFLOW_FROM_PROMPT = 'createWorkflowFromPrompt';

export const fetchWorkflowAssistantFeatures = async (opts: {
  projectName: string;
  getToken: () => Promise<string | null>;
}): Promise<WorkflowAssistantFeature[]> => {
  const accessToken = await opts.getToken();
  if (!accessToken) {
    throw new Error('Failed to get access token for workflow assistant features');
  }

  const url = `${getLogicEndpoint()}/automationProjects/${encodeURIComponent(opts.projectName)}/workflowAssistants/default/features?api-version=${apiVersions.otto}`;
  const response = await appFetch<WorkflowAssistantFeaturesResponse>(
    url,
    accessToken,
    { cache: 'no-store' },
    { features: [] },
  );
  return response?.features ?? [];
};

export const isFeatureEnabled = (
  features: WorkflowAssistantFeature[] | undefined,
  featureName: string,
): boolean => (features ?? []).some((f) => f.featureName === featureName && f.value === true);
